module.exports = __webpack_public_path__ + "static/media/lincoln-provider.92e7c539.svg";